import React from 'react';
import { keyframes, Primitive, styled } from '@miro-site/ui-styled-engine';
import { Section, Grid, GridItem, Box, Image, Typography } from '@miro-site/ui-core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var marquee = keyframes({
  '0%': {
    left: '100%'
  },
  '100%': {
    left: '-100%'
  }
});
var marqueeMobile = keyframes({
  '0%': {
    left: '200%'
  },
  '100%': {
    left: '-200%'
  }
});
var SocialLogosContainer = styled(Primitive.div, {
  overflow: 'hidden',
  position: 'relative',
  height: '40px',
  '@md': {
    height: '45px'
  },
  '&::before': {
    content: '""',
    background: 'linear-gradient(90deg, #FFFFFF 48.13%, rgba(255, 255, 255, 0) 80.49%)',
    height: '100%',
    width: '20px',
    position: 'absolute',
    left: '0',
    zIndex: '1',
    '@lg': {
      width: '40px'
    }
  },
  '&::after': {
    content: '""',
    background: 'linear-gradient(270deg, #FFFFFF 48.13%, rgba(255, 255, 255, 0) 80.49%)',
    height: '100%',
    width: '20px',
    position: 'absolute',
    right: '0',
    zIndex: '1',
    '@lg': {
      width: '40px'
    }
  },
  '.social-logos-container': {
    top: '0',
    left: '100%',
    width: '200%',
    overflow: 'hidden',
    position: 'absolute',
    whiteSpace: 'nowrap',
    animation: "".concat(marqueeMobile, " 20s linear infinite"),
    '@sm': {
      width: '100%',
      animation: "".concat(marquee, " 20s linear infinite")
    },
    '&.container-2': {
      animationDelay: '10s'
    }
  }
});

var SocialProof = function SocialProof(props) {
  var _props$logos, _props$logos2;

  return /*#__PURE__*/_jsx(Section, {
    css: {
      position: 'relative',
      zIndex: 1
    },
    children: /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsxs(Grid, {
        children: [/*#__PURE__*/_jsx(GridItem, {
          css: {
            display: 'flex',
            alignItems: 'center'
          },
          columnStart: "1",
          columnEnd: {
            '@initial': -1,
            '@lg': 6
          },
          children: /*#__PURE__*/_jsx(Typography, {
            variant: "body-text-1",
            css: {
              textAlign: 'center',
              width: '100%',
              '@lg': {
                textAlign: 'left'
              }
            },
            children: props === null || props === void 0 ? void 0 : props.content
          })
        }), /*#__PURE__*/_jsx(GridItem, {
          lg: 7,
          xs: 12,
          children: /*#__PURE__*/_jsx(SocialLogosContainer, {
            asChild: true,
            children: /*#__PURE__*/_jsxs("div", {
              className: "social-logos-container",
              children: [/*#__PURE__*/_jsx(Box, {
                css: {
                  display: 'flex'
                },
                asChild: true,
                children: /*#__PURE__*/_jsx("div", {
                  className: "social-logos-container container-1",
                  children: props === null || props === void 0 ? void 0 : (_props$logos = props.logos) === null || _props$logos === void 0 ? void 0 : _props$logos.map(function (logo, index) {
                    if (logo && logo.src) return /*#__PURE__*/_jsx(Image, {
                      image: logo
                    }, 'socialproof-' + index);
                  })
                })
              }), /*#__PURE__*/_jsx(Box, {
                css: {
                  display: 'flex'
                },
                asChild: true,
                children: /*#__PURE__*/_jsx("div", {
                  className: "social-logos-container container-2",
                  children: props === null || props === void 0 ? void 0 : (_props$logos2 = props.logos) === null || _props$logos2 === void 0 ? void 0 : _props$logos2.map(function (logo, index) {
                    if (logo && logo.src) return /*#__PURE__*/_jsx(Image, {
                      image: logo
                    }, 'socialproof-set2-' + index);
                  })
                })
              })]
            })
          })
        })]
      })
    })
  });
};

export default SocialProof;